import {useCallback} from 'react';
import './Toast.scss';
import {SvgIcon} from '../svgIcon/SvgIcon';

interface IToast {
  type: 'success' | 'info' | 'error' | 'warning';
  text: string;
  onClose?: () => void;
}

export const Toast = (props: IToast) => {
  const {type, text, onClose} = props;

  const handleClose = useCallback(() => {
    if (onClose) {
      onClose();
    }
  }, [onClose]);

  return (
    <div className={`toast ${type}`} onClick={handleClose}>
      <div className="toast-content">
        <span className="toast-icon">
          <SvgIcon icon={`icon-${type}`} />
        </span>
        <span className="toast-text">{text}</span>
      </div>
      {onClose && (
        <button
          className="toast-close-btn"
          onClick={(e) => {
            e.stopPropagation();
            handleClose();
          }}
          aria-label="Close toast"
        >
          ✕
        </button>
      )}
    </div>
  );
};
